import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { EncryptionMethod, SSLMode } from '../../registries/consts/postgre-consts';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { azureCloudTypeDef, azureDefaultAuthRefTypes, getSqlPEResourceIDAndName, Credential, IPrivateEndpointCompatible, shellStringResources, validateAKVLinkedServiceReference, ParameterConfig } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { AzurePostGreSqlAdditionalPropertiesKeyType } from '../adapters/linkedservices/azure-db-postgre-linkedservice.adapter';

@Metamodel.model({
    name: adfModelTypeMap.azurePostgreSQL.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzurePostgreSql_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzurePostgreSql_DisplayText)
    ]
})
export class AzurePostgreSqlLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;
    public static readonly SERVER_NAME: IAttribute;
    public static readonly DATABASE_NAME: IAttribute;
    public static readonly PORT: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly SSL_MODE: IAttribute;

    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;
    public static readonly SERVICE_PRINCIPAL_EMBEDDED_CERT: IAttribute;
    public static readonly SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD: IAttribute;
    public static readonly TENANT: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName,
        association: 'SERVER_NAME',
        templatable: true
    })
    public serverName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'PORT',
        templatable: true,
        accepts: ['String', 'Int']
    })
    public port?: number = 5432;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE_NAME',
        templatable: true
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version: driverVersions;

    @Metamodel.attribute({
        display: stringResources.SSL_Mode,
        association: 'SSL_MODE',
        templatable: true
    })
    public sslMode: number = SSLMode.Perfer;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable: true
    })
    public tenant: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        templatable: true
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalCredentialType
    })
    public servicePrincipalCredentialType?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalKey,
        association: 'SERVICE_PRINCIPAL_KEY',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: validateAKVLinkedServiceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalEmbeddedCert,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_EMBEDDED_CERT',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalEmbeddedCert?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalEmbeddedCertPassword,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalEmbeddedCertPassword?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AzureCloudType
    })
    public azureCloudType?: azureCloudTypeDef;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public credential?: Credential;

    public authenticationType: string = 'Basic';

    public authReferenceMethod: string = azureDefaultAuthRefTypes.InlineRefTypeAuthentication;

    public isOldResource: boolean;
    public encryptionMethod: EncryptionMethod = EncryptionMethod.NoEncryption;
    public validateServerCertificate: boolean = false; // update default value as false


    public override parameterizableAdditionalFields: Array<ParameterConfig<AzurePostGreSqlAdditionalPropertiesKeyType>>;

    private _serverResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        return getSqlPEResourceIDAndName(this.serverName, this._serverResourceID);
    }

    public setPEResourceID(id: string): void {
        this._serverResourceID = id;
    }
}
